const useId = (id?: string | null) => {
  const getId = (key?: string) => {
    if (key) {
      return id ? `${id}-${key}` : undefined
    }
    return id || undefined
  }

  const getTestId = (key?: string) => {
    return getId(key) || null
  }

  return { getId, getTestId }
}

export default useId
